import { SceneObjectBase } from '../../core/SceneObjectBase.js';
import { patchGetAdhocFilters } from './patchGetAdhocFilters.js';
import { getDataSourceSrv } from '@grafana/runtime';
import { AdHocFiltersVariableUrlSyncHandler } from './AdHocFiltersVariableUrlSyncHandler.js';
import { useStyles2 } from '@grafana/ui';
import React from 'react';
import { ControlsLabel } from '../../utils/ControlsLabel.js';
import { AdHocFilterRenderer } from './AdHocFilterRenderer.js';
import { AdHocFilterBuilder } from './AdHocFilterBuilder.js';
import { css } from '@emotion/css';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class AdHocFilterSet extends SceneObjectBase {
  constructor(initialState) {
    super(__spreadValues({
      name: "Filters",
      filters: [],
      baseFilters: [],
      datasource: null,
      applyMode: "same-datasource",
      layout: "horizontal"
    }, initialState));
    this._urlSync = new AdHocFiltersVariableUrlSyncHandler(this);
    this._scopedVars = { __sceneObject: { value: this } };
    this._dataSourceSrv = getDataSourceSrv();
    if (this.state.applyMode === "same-datasource") {
      patchGetAdhocFilters(this);
    }
  }
  _updateFilter(filter, prop, value) {
    if (value == null) {
      return;
    }
    const { filters, _wip } = this.state;
    if (filter === _wip) {
      if (prop === "value") {
        this.setState({ filters: [...filters, __spreadProps(__spreadValues({}, _wip), { [prop]: value })], _wip: void 0 });
      } else {
        this.setState({ _wip: __spreadProps(__spreadValues({}, filter), { [prop]: value }) });
      }
      return;
    }
    const updatedFilters = this.state.filters.map((f) => {
      if (f === filter) {
        return __spreadProps(__spreadValues({}, f), { [prop]: value });
      }
      return f;
    });
    this.setState({ filters: updatedFilters });
  }
  _removeFilter(filter) {
    if (filter === this.state._wip) {
      this.setState({ _wip: void 0 });
      return;
    }
    this.setState({ filters: this.state.filters.filter((f) => f !== filter) });
  }
  async _getKeys(currentKey) {
    var _a, _b;
    const override = await ((_b = (_a = this.state).getTagKeysProvider) == null ? void 0 : _b.call(_a, this, currentKey));
    if (override && override.replace) {
      return override.values.map(toSelectableValue);
    }
    const ds = await this._dataSourceSrv.get(this.state.datasource, this._scopedVars);
    if (!ds || !ds.getTagKeys) {
      return [];
    }
    const otherFilters = this.state.filters.filter((f) => f.key !== currentKey).concat(this.state.baseFilters);
    let keys = await ds.getTagKeys({ filters: otherFilters });
    if (override) {
      keys = keys.concat(override.values);
    }
    const tagKeyRegexFilter = this.state.tagKeyRegexFilter;
    if (tagKeyRegexFilter) {
      keys = keys.filter((f) => f.text.match(tagKeyRegexFilter));
    }
    return keys.map(toSelectableValue);
  }
  async _getValuesFor(filter) {
    var _a, _b;
    const override = await ((_b = (_a = this.state).getTagValuesProvider) == null ? void 0 : _b.call(_a, this, filter));
    if (override && override.replace) {
      return override.values.map(toSelectableValue);
    }
    const ds = await this._dataSourceSrv.get(this.state.datasource, this._scopedVars);
    if (!ds || !ds.getTagValues) {
      return [];
    }
    const otherFilters = this.state.filters.filter((f) => f.key !== filter.key).concat(this.state.baseFilters);
    let values = await ds.getTagValues({ key: filter.key, filters: otherFilters });
    if (override) {
      values = values.concat(override.values);
    }
    return values.map(toSelectableValue);
  }
  _addWip() {
    this.setState({ _wip: { key: "", value: "", operator: "=", condition: "" } });
  }
  _getOperators() {
    return ["=", "!=", "<", ">", "=~", "!~"].map((value) => ({
      label: value,
      value
    }));
  }
}
AdHocFilterSet.Component = AdHocFiltersSetRenderer;
function AdHocFiltersSetRenderer({ model }) {
  const { filters, readOnly, layout, name } = model.useState();
  const styles = useStyles2(getStyles);
  return /* @__PURE__ */ React.createElement("div", {
    className: styles.wrapper
  }, layout !== "vertical" && /* @__PURE__ */ React.createElement(ControlsLabel, {
    label: name != null ? name : "Filters",
    icon: "filter"
  }), filters.map((filter, index) => /* @__PURE__ */ React.createElement(React.Fragment, {
    key: index
  }, /* @__PURE__ */ React.createElement(AdHocFilterRenderer, {
    filter,
    model
  }))), !readOnly && /* @__PURE__ */ React.createElement(AdHocFilterBuilder, {
    model,
    key: "'builder"
  }));
}
const getStyles = (theme) => ({
  wrapper: css({
    display: "flex",
    gap: theme.spacing(2),
    alignItems: "flex-end"
  }),
  filterIcon: css({
    color: theme.colors.text.secondary,
    paddingRight: theme.spacing(0.5)
  })
});
function toSelectableValue({ text, value }) {
  return {
    label: text,
    value: String(value != null ? value : text)
  };
}

export { AdHocFilterSet, AdHocFiltersSetRenderer };
//# sourceMappingURL=AdHocFiltersSet.js.map
